import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, allowedRoles }) {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div
        className="flex h-screen w-screen items-center justify-center bg-white"
        data-testid="auth-loading-screen"
      >
        <div className="text-sm text-zinc-500 tracking-wide uppercase">Loading...</div>
      </div>
    );
  }

  if (user === false) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  return children;
}
